import React from "react";

const Checkbox = (props) => {
  const { id, name = "checkbox", isChecked, handleCheckChieldElement } = props;
  return (
    <input
      type="checkbox"
      key={id}
      name={name}
      value={id}
      id={id}
      checked={isChecked}
      onClick={handleCheckChieldElement}
    />
  );
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/container/dashboard/pending/reusedcomponent/checkBox.js